import React from "react";
import { Grid } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Order } from "@/types";
import Accordion from "@/components/organisms/AccordionDrawer";
import Text from "@/components/atoms/Text";
import { useAuth } from "@/contexts/AuthContext";

interface AccordionMaterialProps {
  order: Order;
}

const AccordionMaterial = ({ order }: AccordionMaterialProps) => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const salesItemProperties = [...(order.salesItem.salesItemProperties ?? [])].sort(
    (a, b) => a.salesItemPropertyId - b.salesItemPropertyId
  );

  return (
    <Accordion title={t("enumerables:material")}>
      <Grid p={20}>
        {salesItemProperties.map((salesItemProperty) => {
          const matchingProperty = order.properties.find((p) => p.index === salesItemProperty.salesItemPropertyId);
          const label =
            salesItemProperty.salesItemPropertyTranslated.find((tr) => tr.languageId === user?.language.id)
              ?.propertyTranslated ?? salesItemProperty.salesItemPropertyName;

          return (
            <React.Fragment key={salesItemProperty.salesItemPropertyId}>
              <Grid.Col span={3}>
                <Text size="sm" color="secondary">
                  {label}
                </Text>
              </Grid.Col>
              <Grid.Col span={9}>
                <Text size="sm">{matchingProperty?.value ?? "-"}</Text>
              </Grid.Col>
            </React.Fragment>
          );
        })}
      </Grid>
    </Accordion>
  );
};

export default AccordionMaterial;
